import {API} from '@/vue-plugins/api';
const forms = {};
const state = {
  form: {},
  globalIndex: 0,
  data_sources:[],
};

import {upperFirst, camelCase} from 'lodash';
const requireComponentFormControls = require.context('@/components/form/controls', true, /\.vue$/);
const Controls = [];
for (const file of requireComponentFormControls.keys()) {
  const componentConfig = requireComponentFormControls(file);
  const name = file
      .replace(/index.js/, '')
      .replace(/^\.\//, '')
      .replace(/\.\w+$/, '');
  const componentName = upperFirst(camelCase(name));

  Controls.push({
    control: 'Ugo'+componentName,
    name: componentConfig.default.cname,
    corder: componentConfig.default.corder,
    icon: componentConfig.default.icon,
    properties: componentConfig.default.properties || [],
    initModel: componentConfig.default.initModel,
  });
}


Controls.sort((a, b)=>(a.corder==undefined || a.corder>b.corder)?1:-1);

const requireZZLComponentFormControls = require.context('@/components/form/zzl/controls', true, /\.vue$/);
const ZZLControls = [];
for (const file of requireZZLComponentFormControls.keys()) {
  const componentConfig = requireZZLComponentFormControls(file);
  const name = file
      .replace(/index.js/, '')
      .replace(/^\.\//, '')
      .replace(/\.\w+$/, '');
  const componentName = upperFirst(camelCase(name));

  ZZLControls.push({
    control: 'Zzl'+componentName,
    name: componentConfig.default.cname,
    corder: componentConfig.default.corder,
    icon: componentConfig.default.icon,
    properties: componentConfig.default.properties || [],
    initModel: componentConfig.default.initModel,
  });
}


ZZLControls.sort((a, b)=>(a.corder==undefined || a.corder>b.corder)?1:-1);





const getters = {
  form(state) {
    return state.form;
  },
  containers(state) {
    return ['UgoRow', 'UgoSection', 'UgoTabs', 'UgoCol','ZzlRow', 'ZzlSection', 'ZzlTabs', 'ZzlCol'];
  },
  controls(state) {
    return Controls;
  },
  zzl_controls(state) {
    const defs = ['UgoInput', 'UgoTextarea', 'UgoNumber', 'UgoDate', 'UgoCheck', 'UgoSection', 'UgoRadio', 'UgoZzlPreselect', 'UgoDatetime', 'UgoDatetimeRange', 'UgoSignature', 'UgoMonth', 'UgoInputSelect', 'UgoMultiSelect','UgoZzlTable'];
    return Controls.filter((v)=>defs.includes(v.control));
  },
  zzl_api_list(state){
    return state.zzl_api_list;
  },
  zzl_new_controls(state){
    const defs = ['ZzlInput', 'ZzlTextarea', 'ZzlNumber', 'ZzlDate', 'ZzlCheck', 'ZzlSection', 'ZzlRadio', 'ZzlZzlPreselect', 'ZzlDatetime', 'ZzlDatetimeRange', 'ZzlSignature', 'ZzlMonth', 'ZzlInputSelect', 'ZzlMultiSelect','ZzlZzlTable'];
    return ZZLControls.filter((v)=>defs.includes(v.control));
  },
  data_sources(state){
    return state.data_sources
  }

};

const actions = {
  get({commit}, model) {
    const form = forms[model];
    if (form) {
      commit('save', form);
      return Promise.resolve(form);
    } else {
      return API.get(`models/${model}?view=edit`).then((res)=>{
        const form = res.data.data;
        form.model = model;
        commit('save', form);
      });
    }
  },
  getDataSources({commit}){
    return API.get(`oa/data_sources`).then((res)=>{
      commit('saveDataSources', res.data.data);
    })
  },
  getByID({commit}, id) {
    return API.get(`forms/${id}`).then((res)=>{
      const form = res.data.data;
      commit('save', form);
    });
  },
  createGlobaID({commit, state}) {
    commit('add_gid');
    return Promise.resolve(state.globalIndex);
  },
};

const mutations = {
  save(state, form) {
    forms[form.model] = form;
    state.form = form;
  },
  add_gid(state) {
    state.globalIndex = state.globalIndex++;
  },
  saveDataSources(state, dataSources) {
    state.data_sources = dataSources;
  },
};


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
